import React, { useEffect, useState } from "react";
import { FaAngleRight } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  getDynamicQuestion,
  getDynamicExamQuestion,
  getIsLastQuestion,
  submitQuestion,
} from "../../../redux/slice/dynamicExamSlice";
import { getHistory } from "../../../redux/slice/historySlice";
import { getUserID } from "../../../redux/slice/userSlice";
import ExitExamButton from "../examPage/ExitExamButton";
import Timer from "../examPage/Timer";

const DynamicExamForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(1);

  const userId = useSelector(getUserID);
  const question = useSelector(getDynamicExamQuestion);
  const examId = useParams().examId;

  const isLastQuestion = useSelector(getIsLastQuestion);

  const [answer, setAnswer] = useState(null);

  const handleOptionChange = (e) => {
    setAnswer(e.target.value);
  };

  const handleSubmitAnswer = async () => {
    const data = {
      user: userId,
      exam: examId,
      questionId: question._id,
      answerId: answer,
    };
    const result = await dispatch(submitQuestion(data)).unwrap();
    if (!isLastQuestion) {
      await dispatch(getDynamicQuestion(examId)).unwrap();
      setAnswer(null);
    } else {
      dispatch(getHistory(data.user));
      navigate(`/client/result/${result.submitId}`);
    }
  };

  useEffect(() => {
    if (seconds + minutes <= 0) {
      handleSubmitAnswer();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seconds, minutes, userId, examId, answer, dispatch]);

  return (
    <>
      {!question ? (
        <p>
          Error encountered. Go{" "}
          <Link
            className="border-b-2 border-secondary text-secondary"
            to="/client/home"
          >
            Back
          </Link>
          and start the exam again.
        </p>
      ) : (
        <>
          <div className="sticky top-6 sm:self-center self-end">
            <Timer
              minutes={minutes}
              setMinutes={setMinutes}
              seconds={seconds}
              setSeconds={setSeconds}
              time={1 * 60 * 1000}
              question={question}
            />
            {/* <span className="text-textSecondary">Total Questions: {len}</span> */}
          </div>
          <div className="sm:px-8">
            <div className="pb-6">
              <div className="flex flex-col pb-1">
                <p className="text-textPrimary font-medium text-[18px]">
                  {question.questions}
                </p>
                <span className="pl-6 text-sm text-blue-500">
                  ({question.marks} Marks) ({question.level})
                </span>
              </div>
              <div className="flex flex-col gap-2 pl-6">
                {question?.optionsOfAnswer?.map((option) => (
                  <div
                    key={option._id}
                    className="flex flex-row gap-3 items-center"
                  >
                    <input
                      type="radio"
                      name={question._id}
                      id={option._id}
                      value={option._id}
                      onChange={handleOptionChange}
                      className="h-[16px] w-[16px]"
                    />
                    <label htmlFor={option._id} className="font-[18px]] ">
                      {option.option}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="flex justify-between items-center">
            <ExitExamButton
              message="Exit"
              styles="border-2 border-red-500 text-red-500"
            />
            {isLastQuestion ? (
              <button
                onClick={handleSubmitAnswer}
                className="h-[36px] rounded-md text-sm px-6 font-semibold border-2 border-secondary bg-secondary text-primary"
              >
                <span>Submit</span>
              </button>
            ) : (
              <button
                onClick={handleSubmitAnswer}
                className="flex flex-row items-center justify-center gap-2 h-[36px] rounded-md text-sm pl-[38px] pr-[24px] font-semibold border-2 border-secondary bg-transparent text-secondary"
              >
                <span>Next</span>
                <FaAngleRight />
              </button>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default DynamicExamForm;
